export enum CourseTemplate {
    Usual = 1,
    Awareness = 2,
    XTraining = 3,
    CyberHygiene = 4,
    Product = 5,
    EnterIt = 6,
}
